import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  deleteBrandingLogo,
  getBrandingLogo,
  uploadBrandingLogo,
} from "controller/api/control-center/msp";
import { ApiErrorType, UploadBrandingLogoInput } from "shared";
import { sentryLogger } from "utilz";

export const useGetBrandingLogo = () => {
  return useQuery({
    queryKey: ["branding"],
    queryFn: () => getBrandingLogo(),
    enabled: true,
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getBrandingLogo",
      }),
  });
};

export const useUploadBrandingLogo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (value: UploadBrandingLogoInput) => uploadBrandingLogo(value),
    onSuccess: (_, variables, __) => {
      queryClient.invalidateQueries(["branding"]);
    },
    onError(error: ApiErrorType, variables, context) {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "updateMspWordmark",
      });
    },
  });
};

export const useDeleteBrandingLogo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (type: "logo" | "wordmark") => deleteBrandingLogo(type),
    onSuccess: (_, variables, __) => {
      queryClient.invalidateQueries(["branding"]);
    },
    onError(error: ApiErrorType, variables, context) {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "deleteBrandingLogo",
      });
    },
  });
};
